import React from "react"
import PropTypes from "prop-types"
import { Typography, Flex, Spin, Tooltip } from "antd"
import { ArrowUpOutlined, ArrowDownOutlined, InfoCircleOutlined } from "@ant-design/icons"
import styles from "../style.module.css"

const { Text } = Typography

export default function StatsRow({ stats, loadingKeys, kpiKeys }) {
  return (
    <div className={styles.statsRow}>
      {stats.map((stat, i) => {
        const isLoading = loadingKeys && kpiKeys && loadingKeys.has(kpiKeys[i])
        return (
          <div key={stat.label} className={styles.statCard}>
            <Flex align="center" justify="space-between">
              <Text type="secondary" className={styles.statLabel}>{stat.label}</Text>
              {stat.description && (
                <Tooltip title={stat.description} placement="topRight" styles={{ body: { maxWidth: 320 } }}>
                  <InfoCircleOutlined className={styles.widgetInfoIcon} />
                </Tooltip>
              )}
            </Flex>
            {isLoading ? (
              <Flex align="center" justify="center" className={styles.statCardSpinner}><Spin /></Flex>
            ) : (
              <>
                <Text strong className={styles.statValue}>{stat.value}</Text>
                <Flex align="center" gap={4} className={styles.statTrend}>
                  {stat.trend < 0
                    ? <ArrowDownOutlined className={styles.trendDown} />
                    : <ArrowUpOutlined className={styles.trendUpIcon} />
                  }
                  <Text className={`${stat.trend < 0 ? styles.trendDown : styles.trendUpIcon} ${styles.textSm}`}>
                    {Math.abs(stat.trend)}%
                  </Text>
                  <Text type="secondary" className={styles.textSm}>{stat.period}</Text>
                </Flex>
              </>
            )}
          </div>
        )
      })}
    </div>
  )
}

StatsRow.propTypes = {
  stats: PropTypes.array.isRequired,
  loadingKeys: PropTypes.instanceOf(Set),
  kpiKeys: PropTypes.arrayOf(PropTypes.string),
}
